import React, { useState, useEffect } from "react";

import "./Paginator.component.scss";

export interface PaginatorProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (...args: any) => any;
}

export default function Paginator(props: PaginatorProps) {
    const { currentPage, handleChangePage, setCurrentPage } = useChangePage(
        props.currentPage,
        props.onPageChange
    );

    const disabledBack = currentPage === 1;
    const disabledAdv = currentPage === props.totalPages;

    useEffect(() => {
        setCurrentPage(1);
    }, [props.totalPages]);

    useEffect(() => {
        setCurrentPage(props.currentPage);
    }, [props.currentPage]);

    return (
        <div id="Paginator">
            <div
                className={"paginator-back " + (disabledBack ? "disabled" : "")}
                onClick={() => {
                    if (!disabledBack) handleChangePage(-1);
                }}
            >
                <i className="material-icons">keyboard_arrow_left</i>
            </div>

            <div className="paginator-current-page">
                <span className="current-page">{currentPage}</span>
                <span className="separator">/</span>
                <span className="total-pages">{props.totalPages}</span>
            </div>

            <div
                className={"paginator-next " + (disabledAdv ? "disabled" : "")}
                onClick={() => {
                    if (!disabledAdv) handleChangePage(1);
                }}
            >
                <i className="material-icons">keyboard_arrow_right</i>
            </div>
        </div>
    );
}

const useChangePage = (
    initialValue: number,
    callback: (newPage: number) => void
) => {
    const [currentPage, setCurrentPage] = useState(initialValue);

    const handleChangePage = (increaseFactor: number) => {
        const newPage = currentPage + increaseFactor;
        callback(newPage);
        setCurrentPage(newPage);
    };

    return {
        currentPage,
        handleChangePage,
        setCurrentPage
    };
};
